import React, { useEffect, useState } from "react";
import axios from "axios";
import Tilt from "react-parallax-tilt";
import { useTranslation } from "react-i18next";
import "./Services.css";
import { Link } from "react-router-dom";

// swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const Services = () => {
  const { t, i18n } = useTranslation("global");
  const BASE_URL =
    process.env.REACT_APP_BASE_URL || "https://app.xn--mgb9a0bp.com";

  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSubCategories = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${BASE_URL}/api/categories`, {
          headers: {
            Lang: i18n.language,
          },
        });

        const categories = res?.data?.data || [];
        const serviceCategory = categories.find(cat => cat.id === 1);
        const displayCategories = serviceCategory?.sub_categories?.length
          ? serviceCategory.sub_categories
          : categories;

        setSubCategories(displayCategories);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubCategories();
  }, [BASE_URL, i18n.language]);

  return (
    <div className="services py-5">
      <div className="container">
        <h3 className="text-center mb-4 fw-bold main-color">
          {t("services.title")}
        </h3>

        {loading ? (
          <div className="text-center">{t("loading")}</div>
        ) : subCategories.length > 0 ? (
          subCategories.length > 4 ? (
            <Swiper
              modules={[Autoplay]}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              spaceBetween={0}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                },
                576: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                992: {
                  slidesPerView: 5,
                },
              }}
              className="service_swiper"
            >
              {subCategories.map((sub, index) => (
                <SwiperSlide key={sub.id || index}>
                  <div className="service_btns text-center d-flex flex-wrap justify-content-center">
                    <Tilt
                      glareEnable={true}
                      glareMaxOpacity={0.9}
                      glareColor="#fdfdfd"
                      glarePosition="all"
                      glareBorderRadius="20px"
                      className="tilt-button"
                    >
                      <Link
                        to={`/all_services?ad_category_id=${sub?.id}`}
                        className="text-center d-flex flex-wrap justify-content-center"
                      >
                        <img
                          src={sub.image || "/placeholder.jpg"}
                          onError={e => {
                            e.target.onerror = null;
                            e.target.src = "/placeholder.jpg";
                          }}
                          alt={sub.name}
                        />

                        <span className="text-nowrap text-sm">{sub.name}</span>
                      </Link>
                    </Tilt>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <ul className="service_btns text-center d-flex flex-wrap justify-content-center">
              {subCategories.map((sub, index) => (
                <Tilt
                  key={sub.id || index}
                  glareEnable={true}
                  glareMaxOpacity={0.9}
                  glareColor="#fdfdfd"
                  glarePosition="all"
                  glareBorderRadius="20px"
                  className="tilt-button"
                >
                  <Link
                    to={`/all_services?ad_category_id=${sub?.id}`}
                    className="text-center d-flex flex-wrap justify-content-center"
                  >
                    <img
                      src={sub.image || "/placeholder.jpg"}
                      onError={e => {
                        e.target.onerror = null;
                        e.target.src = "/placeholder.jpg";
                      }}
                      alt={sub.name}
                    />

                    <span className="text-nowrap text-sm">{sub.name}</span>
                  </Link>
                </Tilt>
              ))}
            </ul>
          )
        ) : (
          <div className="text-center">{t("no_data_exists")}</div>
        )}

        <div className="text-center mt-4">
          <Link
            to="/request_service"
            className="rounded-5 shadow-sm bg-dark text-white text-sm px-3 request_service_btn"
            style={{ paddingBlock: "6px" }}
          >
            <i className="bi bi-pen text-xs fw-bold mt-1 mx-1"></i>{" "}
            <span>{t("request_service")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Services;
